import { useTranslation } from 'react-i18next';
import { CustomColumnProps } from './types';

/** Displays Assigning/Issuing CNA for a given CVE.
 *
 * > Note: Has special logic for the fact that '' is Microsoft.
 */
export const AssigningCnaColumn = ({ column, item }: CustomColumnProps) => {
  const [t] = useTranslation(['translation', 'vulnerability']);
  if (!column.fieldName) {
    return <>-</>;
  }
  const assigningCnaValue = item?.[column?.fieldName];

  // if there is no assigning CNA value at all, show -,
  // but allow '' to pass to since that means "Microsoft"
  if (assigningCnaValue === undefined || assigningCnaValue === null) {
    return <>-</>;
  }

  const isMicrosoft = assigningCnaValue.length < 2;
  const assigningCna = isMicrosoft
    ? t('Microsoft', 'Microsoft')
    : assigningCnaValue;
  //TODO: special display logic for not microsoft, make microsoft softer
  return assigningCna;
};
